module.exports = __webpack_public_path__ + "static/media/file-download.7f1e3700.svg";